// import React from 'react'
// import { Link, useLocation } from 'react-router-dom'
// import bicepsSvg from '../../../../assets/biceps.svg'
// import logger from '../../../../utils/logger'
// import { a } from 'framer-motion/client'



// export const CustomListItem = ({
//     clickedBtn,
//     index,
//     functionBtn,
//     icon,
//     title,
//     url,
//     defaultSelected
// }) => {

//     const isExternal = url.startsWith("http")

//     const location = useLocation()
//     logger.debug('location is: ', location.pathname, 'and URL is: ', url)

//     return (
//         <li className={`li-menu ${location.pathname === `/${url}` ? 'li-menu-selected' :
//             defaultSelected ? 'li-menu-selected' : ''} `}

//         >
//             {index !== 8 ?

//                 <Link
//                     className="a-management"
//                     to={`/${url}`}
//                     data-id={index}
//                     onClick={functionBtn}
//                 >
//                     {index === 3 ?
//                         <>
//                             <img src={bicepsSvg} className='biceps-svg' alt={title} />
//                             <p className="p-management d-none d-md-block">{title}</p>
//                         </>
//                         :
//                         <>
//                             <span
//                                 className="material-symbols-outlined notranslate" aria-hidden="true">{icon}</span>
//                             <p className="p-management d-none d-md-block">{title}</p>
//                         </>
//                     }

//                 </Link>
//                 :

//                 <a
//                     className="a-management"
//                     href={isExternal ? url : `/${url}`}
//                     data-id={index}
//                     onClick={functionBtn}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                 >
//                     <>
//                         <span
//                             className="material-symbols-outlined notranslate" aria-hidden="true">{icon}</span>
//                         <p className="p-management d-none d-md-block">{title}</p>
//                     </>

//                 </a>


//             }
//         </li>
//     )
// }


import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import bicepsSvg from '../../../../assets/biceps.svg'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import './customListItem.css'


export const CustomListItem = ({
    index,
    functionBtn,
    icon,
    title,
    url,
    isActive
}) => {


    const [isLarge, setIsLarge] = useState(window.innerWidth > 1000);

    useEffect(() => {
        const checkSize = () => setIsLarge(window.innerWidth > 1000);
        window.addEventListener('resize', checkSize);
        return () => window.removeEventListener('resize', checkSize);
    }, [])


    const isExternal = url.startsWith('http')

    return (
        <li className={`li-menu ${isActive ? 'li-menu-selected' : ''}`}>

            {index !== 8 ? (
                <Link
                    className="a-management"
                    to={`/${url}`}
                    data-id={index}
                    onClick={functionBtn}
                >
                    {index === 3 ? (
                        <>

                            <OverlayTrigger
                                placement="right"
                                
                                trigger={isLarge ? [] : ['hover', 'focus']}
                                overlay={<Tooltip className="mi-tooltip-custom" id={`tooltip-${title}`}>{title}</Tooltip>}
                            >
                                <img src={bicepsSvg} className="biceps-svg" alt={title} />
                            </OverlayTrigger>
                            <p className="p-management d-none d-lg-block">{title}</p>
                        </>
                    ) : (
                        <>

                            <OverlayTrigger
                                placement="right"
                              
                                trigger={isLarge ? [] : ['hover', 'focus']}
                                overlay={<Tooltip className="mi-tooltip-custom" id={`tooltip-${title}`}>{title}</Tooltip>}
                            >
                                <span className="material-symbols-outlined notranslate">
                                    {icon}
                                </span>
                            </OverlayTrigger>

                            <p className="p-management d-none d-lg-block">{title}</p>
                        </>
                    )}
                </Link>
            ) : (
                <a
                    className="a-management"
                    href={isExternal ? url : `/${url}`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <OverlayTrigger
                        placement="right"
                        
                        trigger={isLarge ? [] : ['hover', 'focus']}
                        overlay={<Tooltip className="mi-tooltip-custom" id={`tooltip-${title}`}>{title}</Tooltip>}
                    >
                        <span className="material-symbols-outlined notranslate">
                            {icon}
                        </span>
                    </OverlayTrigger>

                    <p className="p-management d-none d-lg-block">{title}</p>
                </a>
            )}
        </li>
    )
}

